import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { UtilsService } from './utils.service';

@Injectable({
   providedIn: 'root'
})


export class GroupsHandlerService {

   utentiSubject = new Subject();

   groupData: any;
   groupPermissions: number[] = new Array();
   groupFeatures: number[] = new Array();


   // TODO id impostato dopo la login tramite token?
   id = 1;

   constructor(
      private utils: UtilsService) { }

   /**
    * @param parameters "{ids:['1','2','3']}"
    * @returns
    */
   groupGet(parameters: { [param: string]: string[]; }): Observable<unknown> {
      return this.utils.getRequest(this.utils.creaURL('group', 'get'), parameters);
   }

   groupAdd(data: any): Observable<any> {
      return this.utils.postRequest(this.utils.creaURL('group', 'add'), data);
   }

   groupUpdate(body: any, httpOptions?: any): Observable<unknown> {
      return this.utils.putRequest(this.utils.creaURL('group', 'update'), body, httpOptions);
   }

   groupDelete(data: any): Observable<any> {
      return this.utils.deleteRequest(this.utils.creaURL('group', 'delete'), data);
   }

   groupList(): Observable<any> {
      return this.utils.getRequest(this.utils.creaURL('group', 'list'), {});
   }

   groupListOfLoggedUser(data:any): Observable<any> {
      // console.log("DATA--->",data)
      return this.utils.getRequest(this.utils.creaURL('group', 'listOfLoggedUser'), data);
   }

   groupSetProperties(group: any) {

      // GROUP's PROPERTIES
      this.groupData = group.properties;

      // PERMISSIONS
      group.permissions.forEach(p => {
         this.groupPermissions.push(p.id);

         // FEATURES
         if(p.features){

          p.features.forEach(f => {
            this.groupFeatures.push(f.id);
         })};
      });

   }

   /**
    * To check if the group has the specific feature
    */
   isEnabled(toFind) {
      // console.log("+++ FEAT", this.groupFeatures);
      // console.log("IS ENABLED", toFind)

      if (!this.groupFeatures || this.groupFeatures.length === 0) {
         return false;
      }

      if (this.groupFeatures.find((el) => el === toFind)) {
         // console.log("IS ENABLED TRUE")
         return true;
      } else {
         // console.log("IS ENABLED FALSE")
         return false;
      }
   }
}